// src/utils/analytics.ts
import ReactGA from 'react-ga4';

// Initialize with your Measurement ID
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';
  
  if (measurementId && process.env.NODE_ENV === 'production') {
    ReactGA.initialize(measurementId);
    
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }
};

// Track page views
export const trackPageView = (path: string) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

// Track custom events
export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

// Track form submissions
export const trackFormSubmission = (formName: string) => {
  trackEvent('Form', 'Submit', formName);
};

// Track button clicks
export const trackButtonClick = (buttonName: string) => {
  trackEvent('Button', 'Click', buttonName);
};

// Track CTA clicks
export const trackCTAClick = (ctaName: string) => {
  trackEvent('CTA', 'Click', ctaName);
};

// Track social shares
export const trackSocialShare = (platform: string) => {
  trackEvent('Social', 'Share', platform);
};

// Track scrolling (50%, 75%, 100%)
export const trackScrollDepth = (depth: string) => {
  trackEvent('Scroll', 'Depth', depth);
};

// NEW: Track form view (when form becomes visible)
export const trackFormView = (formName: string) => {
  trackEvent('Form', 'View', formName);
};